export default "__VITE_ASSET__BrLy6QxT__"